/* eslint-disable no-undef */
import Cookies from 'js-cookie';
import {useReducer} from 'react';

import {getAWSToken} from '../catapult';

const ACTIONS = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  AWSLOGINFAILED: 'AWSLOGINFAILED',
  INVALIDLOCALCLOCK: 'INVALIDLOCALCLOCK',
  TIMEDOUT: 'TIMEDOUT'
};

function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.LOGIN:
      if (!state.invalidClockError) {
        return setReducerStare({loggedIn: true});
      } else {
        return state;
      }
    case ACTIONS.LOGOUT:
      return setReducerStare({loggedOut: true});

    case ACTIONS.AWSLOGINFAILED:
      if (!state.invalidClockError) {
        return setReducerStare({catapultError: true});
      } else {
        return state;
      }
    case ACTIONS.INVALIDLOCALCLOCK:
      return setReducerStare({invalidClockError: true});
    case ACTIONS.TIMEDOUT:
      return setReducerStare({timedOut: true});
    default:
      return state;
  }
}

export default function (timeoutDuration, intervalDuration) {
  const hasCBCookie = Boolean(Cookies.get('cb_login'));
  const isCBLoggedIn = cb.core.iam.getAuthSession().isLoggedIn;
  const IAMBus = cb.core.iam.getEventBus();
  const eventBus = cb.core.iam.events;
  let logoutFn;

  const [authentication, dispatchAuthentication] = useReducer(reducer, {
    loggedIn: isCBLoggedIn,
    loggingIn: (!isCBLoggedIn || !getAWSToken()) && hasCBCookie,
    loggedOut: false,
    catapultError: false,
    invalidClockError: false,
    timedOut: false
  });

  IAMBus.on(eventBus.AWSLogin, () => {
    setAWSCredInterval(dispatchAuthentication, intervalDuration, timeoutDuration);
  });

  IAMBus.on(eventBus.Logout, () => {
    clearTimeout(logoutFn);
    // To circumvent the issue where we get a Logout event on password confirmation.
    logoutFn = setTimeout(() => {
      if (!cb.core.iam.getAuthSession().isLoggedIn) {
        dispatchAuthentication({
          type: ACTIONS.LOGOUT
        });
      }
    }, 500);
  });

  IAMBus.on(eventBus.AWSLoginFailed, () => {
    dispatchAuthentication({type: ACTIONS.AWSLOGINFAILED});
  });

  IAMBus.on(eventBus.InvalidLocalClock, () => {
    dispatchAuthentication({type: ACTIONS.INVALIDLOCALCLOCK});
  });

  return authentication;
}

function setAWSCredInterval(dispatch, intervalDuration = 100, timeout = 20000) {
  if (getAWSToken()) {
    dispatch({type: ACTIONS.LOGIN});
  } else {
    let duation = 0;
    const interval = setInterval(() => {
      const revisitCreds = getAWSToken();
      if (revisitCreds) {
        dispatch({type: ACTIONS.LOGIN});
      } else {
        duation += intervalDuration;
      }
      if (duation >= timeout) {
        dispatch({type: ACTIONS.TIMEDOUT});
      }
      if (duation >= timeout || revisitCreds) {
        clearInterval(interval);
      }
    }, intervalDuration);
  }
}

function setReducerStare(state) {
  return {
    loggedIn: false,
    loggingIn: false,
    loggedOut: false,
    catapultError: false,
    invalidClockError: false,
    timedOut: false,
    ...state
  };
}